import React from 'react';
import Styles from './TextHeadline.css';

function TextHeadline({ ...props }) {
  return (
    <>
      <h2 {...props} className={`text-headline ${props.className}`} />
      <style jsx>{Styles}</style>
    </>
  );
}

export default TextHeadline;
